if (!customElements.get('adev-main-product')) {
    customElements.define('adev-main-product', class adevMainProduct extends HTMLElement {
        constructor() {
            super();
        }

        initVariantsPicker(){
            this.querySelectorAll('[data-adev-main-product="variant-option"]').forEach(option => {

                const selectedValueEl = option.querySelector('[data-adev-main-product="variant-option-selected-value"]');

                option.querySelectorAll('[data-adev-main-product="variant-option-value"]').forEach(input => {
                    input.addEventListener('change', () => {
                        if (selectedValueEl) {
                            selectedValueEl.innerText = input.value;
                        }

                        this.refresh();
                    })
                });

            });
        }

        formatMoney(t,e){
            function n(t,e){return void 0===t?e:t}function o(t,e,o,i){if(e=n(e,2),o=n(o,","),i=n(i,"."),isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(r[1]?i+r[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var i="",r=/\{\{\s*(\w+)\s*\}\}/,a=e||window.adev_theme.moneyFormat;switch(a.match(r)[1]){case"amount":i=o(t,2);break;case"amount_no_decimals":i=o(t,0);break;case"amount_with_comma_separator":i=o(t,2,".",",");break;case"amount_with_space_separator":i=o(t,2," ",",");break;case"amount_with_period_and_space_separator":i=o(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=o(t,0,".",",");break;case"amount_no_decimals_with_space_separator":i=o(t,0," ");break;case"amount_with_apostrophe_separator":i=o(t,2,"'",".")}return a.replace(r,i)
        }

        setCurrentVariant(){
            const checkedInputs = this.querySelectorAll('[data-adev-main-product="variant-option-value"]:checked');

            if (checkedInputs.length > 0) {
                this.variantOptions = Array.from(checkedInputs).map(input => {
                    return input.value;
                });

                this.currentVariant = this.variantsData.find((variant) => {
                    return !variant.options.map((option, index) => {
                        return this.variantOptions[index] === option
                    })
                    .includes(false);
                });
            } else {
                this.currentVariant = this.variantsData[0];
            }
        }

        getCurrentVariant(){
            return this.currentVariant;
        }

        updatePrice(){
            this.salePriceEls.forEach(salePriceEl => {
                salePriceEl.innerHTML = this.formatMoney(this.currentVariant.price);
            });

            if (this.pricesWrapEl) {
                this.pricesWrapEl.setAttribute('data-on-sale', this.currentVariant.compare_at_price > this.currentVariant.price);
            }

            if (!this.wasPriceEl) return;

            if (this.currentVariant.compare_at_price > this.currentVariant.price) {
                const strike = document.createElement('s');
                strike.innerHTML = this.formatMoney(this.currentVariant.compare_at_price);

                this.wasPriceEl.innerHTML = strike.outerHTML;
            } else {
                this.wasPriceEl.innerHTML = '';
            }
        }

        updatePriceForSubscription(detail){
            if (!detail || !detail.price) return;

            this.salePriceEls.forEach(salePriceEl => {
                salePriceEl.innerHTML = this.formatMoney(detail.price);
            });

            if (this.pricesWrapEl) {
                this.pricesWrapEl.setAttribute('data-on-sale', detail.compareAtPrice > detail.price);
            }

            if (!this.wasPriceEl) return;

            if (detail.compareAtPrice > detail.price) {
                const strike = document.createElement('s');
                strike.innerHTML = this.formatMoney(detail.compareAtPrice);

                this.wasPriceEl.innerHTML = strike.outerHTML;
            } else {
                this.wasPriceEl.innerHTML = '';
            }
        }

		updateFormVariantInputs(){
			const currentVariant = this.currentVariant;
			if (!currentVariant) return;

			this.querySelectorAll('[name="id"]').forEach(input => {
				input.value = currentVariant.id;
				input.dispatchEvent(new Event('change'));
			});
		}

        updateVariantStatuses(){
            const selectedOptionOneVariants = this.variantsData.filter(variant => {
                const firstCheckedInput = this.querySelector('[data-adev-main-product="variant-option-value"]:checked');
				return firstCheckedInput && firstCheckedInput.value === variant.option1
			});

			const options = this.querySelectorAll('[data-adev-main-product="variant-option"]')
			options.forEach((option, index) => {
				if(index === 0) {
					return;
				}

				const previousOptionSelected = options[index - 1].querySelector(':checked').value;

				const availableOptionInputsValue = selectedOptionOneVariants
					.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected)
					.map(variant => variant[`option${ index + 1 }`]);

				const optionInputs = option.querySelectorAll('[data-adev-main-product="variant-option-value"]');

				optionInputs.forEach(input => {
					if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
						input.classList.remove('is--disabled');
					} else {
						input.classList.add('is--disabled');
					}
				});

			});
        }

        updateAddToCart(){
            if (!this.addToCartEl) return;
            
            const span = document.createElement('span');

            let addToCartStuff = '';
            const addToCartSpanTemplate = this.querySelector('[data-adev-main-product="add-to-cart-span"]');
            if (addToCartSpanTemplate) {
                addToCartStuff = addToCartSpanTemplate.innerHTML;
            }
            
            if (this.currentVariant.available) {
                span.innerHTML = addToCartStuff + window.variantStrings.addToCart;
                this.addToCartEl.classList.remove('is--disabled');
                this.addToCartEl.disabled = false;
            } else {
                span.innerHTML = addToCartStuff + window.variantStrings.soldOut;
                this.addToCartEl.classList.add('is--disabled');
                this.addToCartEl.disabled = true;
            }

            this.addToCartEl.innerHTML = span.outerHTML;
        }

        updateMediaGallery(){
            const mediaGalleryEl = this.querySelector('adev-product-media-gallery');

            if (mediaGalleryEl && this.currentVariant) {
                const media = this.variantsData.find(variant => variant.id === this.currentVariant.id);

                if(this.currentVariant.featured_image !== null) {
                    const mediaID = this.currentVariant.featured_media.id;
                    
                    const mediaIndex = this.querySelector(`[data-adev-main-product="media-gallery-item"][data-media-id="${mediaID}"]`);
                    if(mediaIndex){
                        const index = parseInt(mediaIndex.dataset.index, 10);
                        mediaGalleryEl.updateCurrentMedia(index);
                    }
                    
                }
            }
        }

        updateUrl() {
            const url = new URL(window.location);
            url.searchParams.set('variant', this.currentVariant.id);
            window.history.replaceState({}, '', url);
        }

        refresh(){
            this.setCurrentVariant();
            this.updatePrice();
            this.updateFormVariantInputs();
            this.updateVariantStatuses();
            this.updateAddToCart();
            this.updateMediaGallery();
            this.updateUrl();
        }

        isBundle(){
            const picker = this.querySelector('adev-variant-picker-v2');
            return picker !== null;
        }

        getBundleInstance(){
            return this.querySelector('adev-variant-picker-v2');
        }

        refreshVariantPickerV2Availability(){
            const bundlePicker = this.getBundleInstance();

            if (bundlePicker) {
                bundlePicker.dispatchEvent(new Event('adev:update-availability'));
            }
        }

        initAddToCart(){
            if (!this.addToCartEl || !this.form) return;

            this.form.addEventListener('submit', (e) => {
                e.preventDefault();

                const bundlePicker = this.getBundleInstance();

                if (this.isBundle()) {
                    if (!bundlePicker.isValid()) {
                        alert(bundlePicker.getErrorMessage());
                        return;
                    }
                }

                this.addToCartEl.classList.add('is--loading');

                const formData = new FormData(this.form);
                formData.append('id', this.currentVariant.id);

                if (this.isBundle()) {
                    formData.delete('id');
                    formData.delete('quantity');
                }

                formData.append('sections', 'cart-drawer,cart-icon-bubble');
                formData.append('sections_url', window.location.pathname);

                fetch(window.routes.cart_add_url + '.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.status && data.status === 422) {
                        this.refreshVariantPickerV2Availability();
                        alert(data.message);
                        this.addToCartEl.classList.remove('is--loading');
                        return;
                    }

                    if (this.isBundle()) {
                        bundlePicker.resetInputs();
                    }
                    
                    this.addToCartEl.classList.remove('is--loading');
                    
                    this.refreshVariantPickerV2Availability();
                    
                    document.dispatchEvent(new CustomEvent('adev:cart:updated', { detail: data }));
                })
                .catch(error => {
                    this.addToCartEl.classList.remove('is--loading');
                    console.error('Error:', error);
                });

            });
        }

        connectedCallback() {
            const jsonEl = this.querySelector('script[data-adev-main-product="json"]');
            this.variantsData = JSON.parse(jsonEl.textContent);

            this.form = this.querySelector('[data-adev-main-product="form"]');

            this.pricesWrapEl = this.querySelector('[data-adev-main-product="prices"]');
            this.salePriceEls = this.querySelectorAll('[data-adev-main-product="current-price"]');
            this.wasPriceEl = this.querySelector('[data-adev-main-product="regular-price"]');

            this.addToCartEl = this.querySelector('[data-adev-main-product="add-to-cart"]');

            this.setCurrentVariant();

            this.initVariantsPicker();

            this.initAddToCart();

            document.addEventListener('sealsubs:price_update', (e) => {
                const detail = e.detail;
                this.updatePriceForSubscription(detail);
            });
        }

        disconnectedCallback() {
            
        }

    });
}

if (!customElements.get('adev-product-media-gallery')) {
    customElements.define('adev-product-media-gallery', class adevProductMediaGallery extends HTMLElement {
        constructor() {
            super();

            this.mainCarouselEl = this.querySelector('[data-adev-main-product="media-gallery-main"]');
        }

        
        initMainSlider(){
            this._mainSlider = new Flickity(this.mainCarouselEl, {
                cellAlign: 'left',
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                adaptiveHeight: true,
                initialIndex: parseInt(this.dataset.initialIndex, 10) || 0,
            });

            this.initThumbs();

            this.onChange();
            
            this.initArrows();
            this.initDots();

            this.updateDots(this._mainSlider.selectedIndex);

            this.addEventListener('adev:media-gallery:update', (e) => {
                const index = e.detail.index;
                this.updateCurrentMedia(index);
            });
        }

        updateCurrentMedia(index){
            if(this._mainSlider){
                this._mainSlider.select(index);
            }
        }

        initThumbs(){
            this.thumbsCarouselEl = this.querySelector('[data-adev-main-product="thumbnail-gallery"]');

            if (this.thumbsCarouselEl) {
                this._thumbsSlider = new Flickity(this.thumbsCarouselEl, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false,
                    asNavFor: this.mainCarouselEl,
                });
            }
        }

        initArrows(){
            const prevButton = this.querySelector('[data-adev-main-product="media-gallery-prev"]');
            const nextButton = this.querySelector('[data-adev-main-product="media-gallery-next"]');

            if (prevButton && nextButton) {
                prevButton.addEventListener('click', () => {
                    this._mainSlider.previous();
                });

                nextButton.addEventListener('click', () => {
                    this._mainSlider.next();
                });
            }
        }

        initDots(){
            const dots = this.querySelectorAll('[data-adev-main-product="media-gallery-dot"]');

            dots.forEach(dot => {
                dot.addEventListener('click', (e) => {
                    e.preventDefault();

                    const index = dot.dataset.index;
                    this._mainSlider.select(index);
                });
            });
        }

        updateDots(index){
            const dots = this.querySelectorAll('[data-adev-main-product="media-gallery-dot"]');

            dots.forEach(dot => dot.classList.remove('is--active'));

            const activeDot = this.querySelector(`[data-adev-main-product="media-gallery-dot"][data-index="${index}"]`);
            if(activeDot){
                activeDot.classList.add('is--active');
            }
        }

        onChange(){
            this._mainSlider.on('change', (index) => {
                this.updateDots(index);
            });
        }

        destroySlider(){
            if(this._mainSlider){
                this._mainSlider.destroy();
            }
        }

        connectedCallback() {
            this.initMainSlider();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}